import { memo } from "react";
import Chip from "@mui/material/Chip";
import Stack from "@mui/material/Stack";

import type { MessagingPatientAudience } from "../types";

type Props = {
  audiences: MessagingPatientAudience[];
  selectedId: string;
  onChange: (audienceId: string) => void;
  disabled?: boolean;
};

/** Rótulo com contagem; "…" enquanto a lista ainda carrega. */
function chipLabel(audience: MessagingPatientAudience): string {
  const count = audience.isLoading ? "…" : String(audience.patients.length);
  return `${audience.label} (${count})`;
}

/**
 * Troca o público da etapa de seleção do `SendWhatsAppMessageDialog`.
 * A seleção feita em um público continua valendo ao trocar para outro.
 */
export const PatientAudienceSwitcher = memo(
  ({ audiences, selectedId, onChange, disabled = false }: Props) => {
    return (
      <Stack
        direction="row"
        spacing={1}
        useFlexGap
        flexWrap="wrap"
        role="group"
        aria-label="Escolher público para seleção"
      >
        {audiences.map((audience) => {
          const selected = audience.id === selectedId;
          return (
            <Chip
              key={audience.id}
              label={chipLabel(audience)}
              color={selected ? "primary" : "default"}
              variant={selected ? "filled" : "outlined"}
              onClick={() => onChange(audience.id)}
              disabled={disabled}
              aria-pressed={selected}
            />
          );
        })}
      </Stack>
    );
  },
);

PatientAudienceSwitcher.displayName = "PatientAudienceSwitcher";
